import React from "react";
import _ from "lodash";

// npm i lodash@4.17.10
// rfce
const Pagination = (props) => {
  const { itemCount, pageSize, currentPage, onPageChange } = props;
  // console.log(currentPage);

  const pagesCount = Math.ceil(itemCount / pageSize);
  if (pagesCount === 1) return null;
  const pages = _.range(1, pagesCount + 1);

  // nav>ul.pagination>li.page-item>a.page-link;
  return (
    <nav>
      <ul className="pagination">
        {pages.map((page) => (
          <li
            key={page}
            className={page === currentPage ? "page-item active" : "page-item"}
          >
            <a className="page-link" onClick={() => onPageChange(page)}>
              {page}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Pagination;
